import { browser } from "$app/environment";
import { derived, writable } from "svelte/store";
import { mode, setMode, toggleMode } from "mode-watcher";

type Theme = "light" | "dark";

function getCurrentTheme(): Theme {
  return mode.current === "dark" ? "dark" : "light";
}

export const theme = writable<Theme>("light");

function syncThemeState(): void {
  theme.set(getCurrentTheme());
}

if (browser) {
  syncThemeState();

  const syncFromDom = () => {
    syncThemeState();
  };

  const classObserver = new MutationObserver(syncFromDom);
  classObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });

  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", syncFromDom);
  window.addEventListener("storage", (event) => {
    if (event.key === "theme" || event.key === "mode-watcher-mode") {
      syncThemeState();
    }
  });
}

export const isDarkMode = derived(theme, ($theme) => $theme === "dark");

export function toggleTheme(): void {
  toggleMode();
  syncThemeState();
}

export function setTheme(newTheme: Theme): void {
  setMode(newTheme);
  syncThemeState();
}
